import { combineReducers } from 'redux';

import activatePlaceReducer, { ActivatePlaceState } from './ActivatePlaceReducer';
import announcementReducer, { AnnouncementState } from './AnnouncementReducer';
import authenticationReducer, { AuthenticationState } from './AuthenticationReducer';
import companyReducer, { CompanyReducerState } from './CompanyReducer';
import confirmReservationReducer, { ConfirmReservationState } from './ConfirmReservationReducer';
import countryReducer, { CountryReducerState } from './CountryReducer';
import enableGuestWebReducer, { EnableGuestWebState } from './EnableGuestWebReducer';
import enableReservationsReducer, { EnableReservationsState } from './EnableReservationsReducer';
import errorReducer, { ErrorState } from './ErrorReducer';
import feedbackReducer, { FeedbackState } from './FeedbackReducer';
import fetchStateReducer, { FetchStateType } from './FetchStateReducer';
import guestsAnalyticsReducer, { GuestsAnalyticsReducerState } from './GuestsAnalyticsReducer';
import languageReducer, { LanguageState } from './LanguageReducer';
import layoutReducer, { LayoutState } from './LayoutReducer';
import managementPageReducer, { ManagementPageState } from './ManagementPageReducer';
import menucategoriesReducer, { MenuCategoriesReducerState } from './MenuCategoriesReducer';
import notificationReducer, { NotificationState } from './NotificationReducer';
import placeReducer, { PlaceReducerState } from './PlaceReducer';
import postStateReducer, { PostStateType } from './PostStateReducer';
import registrationReducer, { RegistrationState } from './RegistrationReducer';
import reservationReducer, { ReservationsState } from './ReservationReducer';
import reservationsAnalyticsReducer, { ReservationsAnalyticsReducerState } from './ReservationsAnalyticsReducer';
import settingsReducer, { SettingState } from './SettingsReducer';
import subscriptionReducer, { SubscriptionReducerState } from './SubscriptionReducer';

export class Store {
  public readonly error: ErrorState;

  public readonly language: LanguageState;

  public readonly country: CountryReducerState;

  public readonly authentication: AuthenticationState;

  public readonly activatePlaceState: ActivatePlaceState;

  public readonly enableReservationsState: EnableReservationsState;

  public readonly enableGuestWebState: EnableGuestWebState;

  public readonly settings: SettingState;

  public readonly reservations: ReservationsState;

  public readonly layoutState: LayoutState;

  public readonly plan: any;

  public readonly managementPageState: ManagementPageState;

  public readonly feedback: FeedbackState;

  public readonly notifications: NotificationState;

  public readonly announcements: AnnouncementState;

  public readonly registrationState: RegistrationState;

  public readonly placeReducerState: PlaceReducerState;

  public readonly companyReducerState: CompanyReducerState;

  public readonly subscriptionReducerState: SubscriptionReducerState;

  public readonly fetchState: FetchStateType;

  public readonly postState: PostStateType;

  public readonly menucategoriesState: MenuCategoriesReducerState;

  public readonly guestsAnalyticsState: GuestsAnalyticsReducerState;

  public readonly reservationsAnalyticsState: ReservationsAnalyticsReducerState;

  public readonly confirmReservationState: ConfirmReservationState;
}

export default combineReducers({
  error: errorReducer,
  language: languageReducer,
  country: countryReducer,
  authentication: authenticationReducer,
  activatePlaceState: activatePlaceReducer,
  enableReservationsState: enableReservationsReducer,
  enableGuestWebState: enableGuestWebReducer,
  settings: settingsReducer,
  reservations: reservationReducer,
  layoutState: layoutReducer,
  managementPageState: managementPageReducer,
  postState: postStateReducer,
  feedback: feedbackReducer,
  notifications: notificationReducer,
  announcements: announcementReducer,
  registrationState: registrationReducer,
  companyReducerState: companyReducer,
  placeReducerState: placeReducer,
  fetchState: fetchStateReducer,
  menucategoriesState: menucategoriesReducer,
  guestsAnalyticsState: guestsAnalyticsReducer,
  reservationsAnalyticsState: reservationsAnalyticsReducer,
  subscriptionReducerState: subscriptionReducer,
  confirmReservationState: confirmReservationReducer,
});
